<template>
  <div class="control-confirm">
    <transition
      enter-active-class="anim-turnup"
      leave-active-class="anim-turnup anim-reverse"
      mode="out-in"
    >
      <control-button
        :class="buttonClass"
        :button-style="buttonStyle"
        @click="onTrigger"
        v-if="show === false"
      >{{ label }}</control-button>

      <div
        class="control-confirm-message notification is-small"
        :class="type"
        v-else
      >

        <div
          class="content"
          :class="{ 'hide': loading === true }"
        >
          <slot>
            Please confirm
          </slot>
          <div class="buttons">
            <control-button
              class="is-like-tag is-inverted is-outlined"
              :class="type"
              @click="onAccept"
            >
              {{ labelConfirm }}
            </control-button>

            <control-button
              class="is-like-tag is-inverted is-outlined"
              :class="type"
              @click="onCancel"
            >
              {{ labelCancel }}
            </control-button>
          </div>
        </div>

        <b-loading
          :is-full-page="false"
          :active="loading"
        ></b-loading>

      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ControlConfirm',
  props: {
    buttonClass: { type: String, default: () => 'is-like-tag is-warning' },
    buttonStyle: { type: String, default: () => '7' },
    label: { type: String, default: () => 'confirm' },
    type: { type: String, default: () => 'is-warning-fade' },
    labelConfirm: { type: String, default: () => 'Accept' },
    labelCancel: { type: String, default: () => 'Cancel' },
    loading: { type: Boolean, default: () => false },
  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    // when click accept
    onAccept() {
      this.$emit('done')
    },
    // when cancel (close)
    onCancel() {
      this.show = false
    },
    // when click trigger
    onTrigger() {
      this.show = true
    },
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.control-confirm-message {
  padding: 1.5em 2.3em;
  font-size: $size-7;
  font-weight: $weight-medium;

  .buttons {
    margin-top: 0.5em;
  }

  .fake-loading {
    height: 30px;
  }

  .content.hide {
    opacity: 0;
  }
}
</style>
